export default function ErrorDialog({ error, onClose, onRetry }) {
    if (!error) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-2xl max-w-md w-full overflow-hidden">
                <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 text-white">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center flex-shrink-0">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div>
                            <h3 className="text-xl font-bold">Submission Error</h3>
                            <p className="text-sm text-red-100">Your RSVP could not be sent</p>
                        </div>
                    </div>
                </div>

                <div className="p-6">
                    <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 mb-6">
                        <p className="text-sm font-semibold text-red-800 mb-2">Error Message:</p>
                        <p className="text-sm text-red-700">{error}</p>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-4 mb-6">
                        <p className="text-sm font-semibold text-gray-800 mb-2">💡 What can you do?</p>
                        <ul className="text-sm text-gray-600 space-y-1 list-disc list-inside">
                            <li>Check your internet connection</li>
                            <li>Try again</li>
                            <li>Contact us if the problem persists</li>
                        </ul>
                    </div>

                    <div className="flex gap-3">
                        <button
                            onClick={onRetry}
                            className="flex-1 bg-gradient-to-r from-amber-500 to-orange-600 text-white py-3 px-4 rounded-lg font-semibold hover:from-amber-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl"
                        >
                            🔄 Try Again
                        </button>
                        <button
                            onClick={onClose}
                            className="flex-1 bg-gray-200 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-300 transition-all"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}